const ai_sender_id = process.env.AI_SENDER_ID || "c4439ad9-67b3-4414-a5a9-87a0d0153c58";
const baseURL = process.env.REACT_APP_BASE_URL;
const wsbaseURL = process.env.REACT_APP_WS_URL;

const xmpp_domain = process.env.REACT_APP_XMPP_DOMAIN;
const FILE_SERVER = process.env.REACT_APP_FILE_SERVER;
const return_data = {
    "FILE_SERVER": FILE_SERVER,
    "baseURL": baseURL,
    "xmpp_domain": xmpp_domain,
    "ai_sender_id": ai_sender_id,
}
export { return_data, FILE_SERVER, baseURL, wsbaseURL, ai_sender_id };
